<template>
  <div class="mainContainer">
    <h1 class="text-center">Ottr</h1>
  </div>
</template>
<script>
// import axios from "@/plugins/axios";
import Lang from "@/helpers/lang";
// import { mdiAlert, mdiEyeOff, mdiEye } from "@mdi/js";
// import QrModal from "@/components/general/QrModal.vue";
export default {
  components: {
    // QrModal,
  },
  data() {
    return {
      //
    };
  },
  created() {
    this.locale = Lang.get();
  },
  methods: {
    //
  },
};
</script>
<style lang="scss" scoped></style>
